import { get, isUndefined } from 'lodash-es'

import API_CONSTANTS from '@/js/helper/api-constants.js'
import { CHECKOUT_CONSTANTS, CHECKOUT_PATHS } from '../constants/checkout-constants'
import CHECKOUT_GETTER_TYPES from '../getter-types/checkout-getter-types'
import GETTER_TYPES from '../getter-types'

export default {
  ...Object.keys(CHECKOUT_GETTER_TYPES).reduce(
    (getterTypes, type) => ({
      ...getterTypes,
      [type]: state => get(state, CHECKOUT_PATHS[type]),
    }),
    {},
  ),
  [GETTER_TYPES.COMMENT]: (state, getters) => {
    return get(getters[CHECKOUT_GETTER_TYPES.CLIENT_DATA], CHECKOUT_CONSTANTS.COMMENT, '')
  },
  [GETTER_TYPES.REFERENCE]: (state, getters) => {
    return get(getters[CHECKOUT_GETTER_TYPES.CLIENT_DATA], CHECKOUT_CONSTANTS.REFERENCE, '')
  },
  [GETTER_TYPES.CHECKOUT_BASKET_STEP_READY]: (state, getters) => {
    return !!getters[GETTER_TYPES.BASKET_COUNT]
  },
  [GETTER_TYPES.CHECKOUT_ADDRESS_STEP_READY]: (state, getters) => {
    // return (
    //   !isUndefined(getters[GETTER_TYPES.BASKET_PAYMENT_ADDRESS]) &&
    //   !isUndefined(getters[GETTER_TYPES.BASKET_DELIVERY_ADDRESS])
    // )
    return (
      !isUndefined(getters[GETTER_TYPES.BASKET_PAYMENT_ADDRESS]) &&
      Object.values(getters[GETTER_TYPES.BASKET_CLIENT_DELIVERY_ADDRESSES]).every(adrId => !!adrId)
    )
  },
  [GETTER_TYPES.CHECKOUT_SERVICE_STEP_READY]: (state, getters) => {
    return (
      !isUndefined(getters[GETTER_TYPES.BASKET_PAYMENT_SERVICE_ID]) &&
      !isUndefined(getters[GETTER_TYPES.BASKET_DELIVERY_SERVICE_ID])
    )
  },
  [GETTER_TYPES.CHECKOUT_ADDITIONALINFO_STEP_READY]: () => true,
  [GETTER_TYPES.CHECKOUT_ADDITONALINFO_BASKET]: (state, getters) => {
    const reference = getters[GETTER_TYPES.REFERENCE]
    const comment = JSON.stringify(getters[GETTER_TYPES.CLIENT_DATA])
    const hasReference = !isUndefined(reference) && reference !== ''
    const hasComment = !isUndefined(comment) && comment !== ''
    if (!hasReference && !hasComment) {
      return undefined
    }
    const data = {
      [API_CONSTANTS.ATTRIBUTES]: {
        // [API_CONSTANTS.AIMEOS.BASKET.CONSTANTS.ATTTRIBUTE.ORDER_BASE_CUSTOMERID]:
        //   getters[GETTER_TYPES.CUSTOMER_ID],
        // [API_CONSTANTS.AIMEOS.BASKET.CONSTANTS.ATTTRIBUTE.ORDER_BASE_STATUS]: 1,
      },
    }

    if (hasReference) {
      data[API_CONSTANTS.ATTRIBUTES][
        API_CONSTANTS.AIMEOS.BASKET.CONSTANTS.ATTTRIBUTE.ORDER_BASE_CUSTOMERREF
      ] = reference
    }
    if (hasComment) {
      data[API_CONSTANTS.ATTRIBUTES][
        API_CONSTANTS.AIMEOS.BASKET.CONSTANTS.ATTTRIBUTE.ORDER_BASE_COMMENT
      ] = comment
    }
    return data
  },
  [GETTER_TYPES.CHECKOUT_CREATE_ORDER_DATA]: (state, getters) => {
    const orderBaseId = getters[GETTER_TYPES.BASKET_BASE_ID]
    if (isUndefined(orderBaseId)) {
      return undefined
    }
    return {
      [API_CONSTANTS.ATTRIBUTES]: {
        [API_CONSTANTS.AIMEOS.ORDER.ATTRIBUTE.ORDER_BASEID]: orderBaseId,
      },
    }
  },
  [GETTER_TYPES.CHECKOUT_SUMMARY_STEP_READY]: (state, getters) => {
    return getters[GETTER_TYPES.TOS_AGREED]
  },
}
